import React, { useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { strings } from '/imports/strings';
import { Button } from '/imports/ui/Button';
import { Modal, ModalProps } from '/imports/ui/Modal';
import { Form } from '/imports/ui/Form';
import { toastOnError } from '/imports/ui/utils';
import { FormField } from '/imports/ui/FormField';
import { DateTimeInput } from '/imports/ui/DateTimeInput';
import { consumptionPullHasProblems, pullConsumptionIntervals } from '/imports/api/consumptionIntervals';

const PullConsumptionIntervalsModalStyled = styled(Modal)`
  .timezone {
    padding: 1rem 0;
  }
  .modal-title {
    font-size: 1.5rem;
  }
  .option-buttons {
    display: flex;
    justify-content: center;
    gap: 1rem;
  }
  input {
    display: inline-block;
    width: auto;
    margin-right: 1rem;
  }
`;

interface PullConsumptionIntervalsModalProps {
  meterIds: string[];
  onClose: ModalProps['onClose'];
}

/** Modal for pulling consumption intervals over a from/to range for the given meters. */
export const PullConsumptionIntervalsModal = (props: PullConsumptionIntervalsModalProps) => {
  const meterIds = props.meterIds;
  const [from, setFrom] = useState<Date>();
  const [to, setTo] = useState<Date>();
  const submit = toastOnError(async () => {
    if (!meterIds?.length || !from || !to) return;
    const result = await pullConsumptionIntervals.call({ meterIds, from, to });
    // Queued work has nothing to report yet; a pull that ran says what it managed.
    if (result?.queued !== false) toast.success(strings.Running());
    else if (consumptionPullHasProblems(result)) toast.warn(strings.ConsumptionPullProblems(result.skipped + result.failed, result.filesFailed));
    else toast.success(strings.ConsumptionPullComplete(result.filesProcessed));
  });
  return (
    <PullConsumptionIntervalsModalStyled
      title={strings.PullConsumption()}
      onClose={props.onClose}
    >
      <Form onSubmit={submit}>
        <div className="field-group">
          <FormField field="from">
            <label>{strings.From()}</label>
            <DateTimeInput id="pull-cons-from" value={from} onChange={(from) => setFrom(from)} step="900" />
          </FormField>
        </div>
        <div className="field-group">
          <FormField field="to">
            <label>{strings.To()}</label>
            <DateTimeInput id="pull-cons-to" value={to} onChange={(to) => setTo(to)} step="900" />
          </FormField>
        </div>
        <div className="buttons">
          <Button id="pull-cons-btn" type="submit" disabled={!meterIds[0] || !from || !to}>{strings.PullConsumption()}</Button>
        </div>
      </Form>
    </PullConsumptionIntervalsModalStyled>
  );
};